<!--
  Date and time of the presentation meeting (E2 RF-15, optional since 2026-09-16).
  MatDialog provides the shell; everything inside is Hyper markup.
-->
<div class="modal-header">
  <h4 class="modal-title">
    <i class="ri-presentation-line me-1"></i>
    {{ 'kanban.presentationDate.title' | translate }}
  </h4>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-3">
    {{ 'kanban.presentationDate.subtitle' | translate: { deal: $safeNavigationMigration(data?.card?.name) } }}
  </p>

  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-7">
        <div class="mb-3">
          <label class="form-label" for="presentationDate">{{ 'kanban.presentationDate.date' | translate }}</label>
          <!-- mat-datepicker is one of the five allowed Material components. -->
          <div class="input-group">
            <input id="presentationDate" class="form-control" [matDatepicker]="picker" formControlName="date" />
            <button class="btn btn-light" type="button" (click)="picker.open()" [attr.aria-label]="'kanban.nextAction.openCalendar' | translate">
              <i class="ri-calendar-line"></i>
            </button>
          </div>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
      <div class="col-md-5">
        <div class="mb-3">
          <label class="form-label" for="presentationTime">{{ 'kanban.presentationDate.time' | translate }}</label>
          <input id="presentationTime" type="time" class="form-control" formControlName="time" />
        </div>
      </div>
    </div>
    @if (form.touched && form.invalid) {
      <span class="help-block text-danger"><small>{{ 'kanban.presentationDate.required' | translate }}</small></span>
    }
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()">{{ 'kanban.nextAction.cancel' | translate }}</button>
  <button type="button" class="btn btn-soft-primary" (click)="skip()">{{ 'kanban.presentationDate.skip' | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="confirm()">{{ 'kanban.presentationDate.confirm' | translate }}</button>
</div>
